import { Dispatch } from 'react'
import { atom } from 'recoil'

import { VariantSnackbar } from '@/types/ui/snackbar'

export type GlobalSnackbarAtom = {
    variant: VariantSnackbar
    text: string
    setShow: Dispatch<boolean>
}

/** Global snackbar type. */
export const globalSnackbarAtom = atom<GlobalSnackbarAtom>({
    key: 'globalSnackbarAtom',
    /** @type GlobalSnackbarAtom */
    default: {
        variant: 'info',
        text: '',
        setShow: () => {
            /* Empty */
        },
    },
})
